import { layoutEffectsSymbol } from './symbols.js';
import { createEffect } from './create-effect.js';
function setLayoutEffects(state, cb) {
    state[layoutEffectsSymbol].push(cb);
}
const useLayoutEffect = createEffect(setLayoutEffects);
export { useLayoutEffect };
